import createClient from 'openapi-fetch';

import { API_URL } from '../lib/env';

import { fetchApi } from './network';
import type { paths } from './schema';

/** Client sans jeton : connexion et renouvellement de session uniquement. */
export const publicApi = createClient<paths>({ baseUrl: API_URL, fetch: fetchApi });
